<script>
import request from '@utils/request'

export default {
  props: {
    tryingSave: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    showUpload: {
      type: Boolean,
      default: false,
    },

    single: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    // const toList = ()=>{
    //   if(!this.value){
    //     return []
    //   }
    //   return this.value.map(item =>{
    //       return {
    //         url:item
    //       }
    //     })
    // }
    return {
      // fileList: Object.assign([], this.value),
      // fileList:toList(),
      tryingToUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      cacheList: [],
    }
  },
  computed: {
    showUploadBtn() {
      return this.single ? this.value.length === 0 : true
    },
  },
  watch: {
    // fileList() {
    //   this.$nextTick(() => {
    //     this.checkPlusDisabled()
    //   })
    // },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // tryToGetFileList(){
    //    if(!this.value){
    //     this.fileList = []
    //   }else{
    //     this.fileList = this.value.map(item =>{
    //       return {
    //         url:item
    //       }
    //     })
    //   }

    // },
    // emitInput() {
    //   this.$emit('input', [...this.fileList])
    // },
    beforeImageUpload(fileList) {
      let pass = true
      fileList.forEach((file) => {
        if (pass) {
          const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif'
          const isLt2M = file.size / 1024 / 1024 <= 10
          if (!isJPGOrPNG) {
            this.$message.error('上傳的圖片只能是 JPG 或 PNG 或 GIF 格式')
          }
          if (!isLt2M) {
            this.$message.error('上傳的圖片大小不能超過 10 MB')
          }
          pass = isJPGOrPNG && isLt2M
        }
      })

      return pass
    },
    /**
     * @description 上傳圖片
     */
    async handleUpload() {
      try {
        const pass = this.beforeImageUpload(this.cacheList)
        if (!pass) {
          return Promise.reject(new Error('Error'))
        }
        const formData = new FormData()
        this.cacheList.forEach((item, index) => {
          formData.append('images[]', item, index)
        })
        this.tryingToUpload = true
        this.$emit('update:tryingSave', true)
        const uploadedValue = await request.post('/admin/comment/media/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        const images = uploadedValue.items.images

        this.tryingToUpload = false
        this.$emit('update:tryingSave', false)
        this.cacheList = []
        return images
      } catch (error) {
        console.error(error.message)
      }

    },
    handlePreview(file) {
      this.dialogImageUrl = file
      this.dialogVisible = true
    },

    changeUpload(val) {
      this.cacheList.push(val.raw)
      this.cacheList = this.cacheList.filter((item, index) => {
        return this.cacheList.indexOf(item) === index
      })
      const updateImage = {
        url: val.url,
        uid: val.uid,
      }
      this.$emit('updateFileList', updateImage)
    },
    tryToRemove(file) {
      this.fileList.forEach((item, index) => {
        if (file.url === item.url) this.fileList.splice(index, 1)
      })
      this.$refs.upload.uploadFiles.forEach((item, index) => {
        if (file.url === item.url) this.$refs.upload.uploadFiles.splice(index, 1)
      })
      this.cacheList.forEach((item, index) => {
        if (file.uid === item.uid) this.cacheList.splice(index, 1)
      })
    },
    handleExceed() {
      this.$message({ message: '一次最多上傳5張照片', type: 'error' })
    }
  },
}
</script>

<template>
  <div v-show="showUpload">
    <!-- <div v-for="(file, index) in fileList" :key="`image-and-action--${index}`" :class="[$style.uploader, 'image-and-action']">
      <el-image v-if="file.path" :src="file.path" fit="cover">
        <div slot="placeholder">
          載入中
          <span class="dot">...</span>
        </div>
      </el-image>
      <span v-if="file.path" :class="$style.actions">
        <el-tooltip effect="dark" content="預覽圖片" placement="top">
          <span @click="handlePreview(file.path)">
            <BaseIcon name="eye" />
          </span>
        </el-tooltip>
        <el-tooltip effect="dark" content="刪除圖片" placement="top">
          <span @click="handleRemove(file.path)">
            <BaseIcon name="trash-alt" />
          </span>
        </el-tooltip>
      </span>
    </div> -->

    <el-upload ref="upload" action="#" list-type="picture-card" :auto-upload="false" :http-request="handleUpload"
      :before-upload="beforeImageUpload" :file-list="fileList" :on-change="changeUpload" :clear-files="false" multiple
      :limit="10" :on-exceed="handleExceed" :class="{ isLimit: fileList.length === 10 }">
      <i slot="default" class="el-icon-plus isStyleCenter"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePreview(file.url)">
            <i class="el-icon-zoom-in"></i>
          </span>

          <span v-if="!disabled" class="el-upload-list__item-delete" @click="tryToRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <p style="color:#c0c4cc;margin:0">圖檔最大 10 MB，檔案格式限 JPG 、 PNG 、 GIF</p>
    <el-dialog :visible.sync="dialogVisible" width="800px" top="0" append-to-body>
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@design';

:global {}

.wrap {

  // display: flex;
  // flex-wrap: wrap;
  // border-top: 1px solid #dcdfe6;
  // padding: 10px 5px 0px;
  // background: white;
  :global {
    .isLimit {
      .el-upload--picture-card {
        display: none;
      }
    }

    .el-upload--picture-card {
      width: calc(20% - 8px) !important;
      // height: 8vw !important;
      height: 0 !important;
      padding-bottom: 18.6%;
      line-height: 0 !important;
      position: relative;

      i {
        &.isStyleCenter {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          bottom: 0;
          transform: translateY(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      // @include max-lg {
      //   height: 14.6vw !important;
      //   line-height: 14.6vw !important;
      //   // width: calc(39% - 8px) !important;
      //   width: 14.6vw !important;
      // }
      // @include max-md {
      //   height: 15.6vw !important;
      //   line-height: 17.6vw !important;
      //   // width: 15.6vw !important;
      //   width: 15.6vw !important;
      // }
    }

    .el-upload-list__item {
      width: calc(20% - 8px);
      // height: 8.6vw;
      height: auto;
      padding-bottom: 18.6%;

      // @include max-lg {
      //   height: 14.6vw
      // }
      // @include max-md {
      //   height: 15.6vw 
      // }
      .el-upload-list__item-thumbnail {
        position: absolute;
        object-fit: cover;
        object-position: center;
      }
    }

    // .image-and-action {
    //   position: relative;
    // }
  }
}

// .uploader {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 23%;
//   height: 130px;
//   margin: 0;
//   overflow: hidden;
//   margin: 0 5px 10px;

//   :global {
//     .el-upload,
//     .el-image {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       width: 100%;
//       height: 100%;
//       color: $color-text-placeholder;
//     }
//   }
//   &__icon {
//     font-size: ms(12);
//   }
//   &__limit {
//     margin-top: 10px;
//     line-height: 1.5;
//     color: $color-text-placeholder;
//   }
//   &--circle {
//     width: 150px;
//     height: 150px;
//     margin: auto;
//     border-radius: 50%;
//     .actions {
//       border-radius: 50%;
//     }
//   }
//   &.is-emtpy {
//     border: 1px dashed $color-text-placeholder;
//     &:hover :global {
//       .el-upload,
//       .el-image {
//         color: darken($color-text-placeholder, 20);
//       }
//     }
//   }
// }

// .add-btn {
//   :global {
//     .el-upload {
//       flex-direction: column;
//       svg {
//         font-size: 30px;
//       }
//       .text {
//         height: auto;
//         line-height: 31px;
//         font-size: 14px;
//       }
//     }
//   }
// }

// .actions {
//   position: absolute;
//   top: 0;
//   left: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 100%;
//   height: 100%;
//   font-size: ms(8);
//   color: white;
//   background-color: rgba(0, 0, 0, 0.5);
//   opacity: 0;
//   transition: $fade-transition;
//   span {
//     cursor: pointer;
//     + span {
//       margin-left: 25px;
//     }
//   }
//   &:hover {
//     opacity: 1;
//   }
// }
</style>
